import styled from 'styled-components'

import StarIcon from '../../../assets/img/Ico_Star.png'
import EmptyStarIcon from './empty-star.png'
import HalfStarIcon from './half-star.png'

export const StarModel = styled.div`
  @media (max-width: 700px) {
    width: 25px;
    height: 25px;
  }
  width: 24px;
  height: 24px;
  margin: 0px 6px 0px 0px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
`

export const Star = styled(StarModel)`
  background-image: url(${StarIcon});
`
export const HalfStar = styled(StarModel)`
  background-image: url(${HalfStarIcon});
`

export const EmptyStar = styled(StarModel)`
  background-image: url(${EmptyStarIcon});
`



// WEBPACK FOOTER //
// ./src/components/StarReviewComponent/StarItem/index.js